export default "__VITE_ASSET__19d3412d__"